var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"add-new-button__text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }